<template>
  <div class="portrait-success-wrapper">
    <w-navbar :icon="'iconchevron-left'"
              nav_title="超级简历证件照"
              @mobileLeftBtn="leftBtnClick"
              :isShowLeftIcon="true" />
    <div class="portrait-success-content">
      <img src="https://files.wondercv.com/m/editor/IDphotoEmpty%20States.png" alt="">
      <h6>上传成功</h6>
      <p>照片已上传成功，请在电脑端继续编辑</p>
    </div>
  </div>
</template>

<script>
import WNavbar from '@/components/global/w-navbar'

export default {
  components: {
    WNavbar
  },
  methods: {
    leftBtnClick() {
      this.$router.push('/cvs')
    }
  }
}
</script>

<style lang="scss" scoped>
  .portrait-success-wrapper {
    width: 100%;

    .portrait-success-content {
      padding-top: 171px;
      display: flex;
      flex-direction: column;
      align-items: center;

      >img {
        width: 138px
      }

      >h6 {
        font-size: 20px;
        font-weight: 500;
        color: #404040;
        line-height: 28px;
      }

      >p {
        margin-top: 6px;
        font-size: 14px;
        font-weight: 400;
        color: #9C9C9C;
        line-height: 20px;
      }
    }
  }
</style>
